import trainings from '@/store/modules/trainings/trainings'
import trainingCreate from '@/store/modules/trainings/training-create'
import trainingEdit from '@/store/modules/trainings/training-edit'
import trainingDelete from '@/store/modules/trainings/training-delete'
import trainingsList from '@/store/modules/trainings/trainings-list'

export default {
  trainings,
  trainingCreate,
  trainingEdit,
  trainingDelete,
  trainingsList
}
